// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination-1jnjY","item":"item-1xFso","item_active":"item_active-1VWbX"};